import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import DommusTabelaPaginada from "../../components/DommusTabelaPaginada";
import { TagsContext } from "../../contexts/TagsContext";
import { Container, Dropdown } from "react-bootstrap";
import DommusBarraTitulo from "../../components/DommusBarraTitulo";
import ItemBarraTitulo from "../../components/DommusBarraTitulo/ItemBarraTitulo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faPen, faPlusCircle, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import ModalDommus from "../../components/Modal";
import "./index.css";
import { FormTagAtendimento } from "./FormTagAtendimento";
import caAPI from "../../services/caAPI";
import { trackPromise } from "react-promise-tracker";
import Swal from "sweetalert2";
import { successToast } from "../../components/DommusToast";

export function TagsAtendimentoPage() {
  const [openModal, setOpenModal] = useState(false);
  const [filtroNome, setFiltroNome] = useState(null);
  const [tagSelecionada, setTagSelecionada] = useState(null);
  const {tagsLista, setTagsLista, recarregarTags} = useContext(TagsContext);

  useEffect(()=>{
    recarregarTags()
  }, [])

  const thead = useMemo(()=>{
    return (
      <tr >
        <th>
          Nome
        </th>
        <th style={{ width: '5%' }} className="text-center">
          Ações
        </th>
      </tr>
    )
  },[])

  const trows = useMemo(()=>{
    return tagsLista.filter((item) => {
      const normalize = (s) => (s || '').normalize('NFD')?.replace(/[\u0300-\u036f\W_]+/g, '').toLowerCase();
      return !filtroNome?.length || normalize(item.nome)?.includes(normalize(filtroNome));
    }).map((tag, index) => {
      return(
        <tr key={index}>
          <th >
            {tag?.nome}
          </th>
          <th className="text-center">
            <Dropdown className="acoes-tabela">
                <Dropdown.Toggle>
                    <FontAwesomeIcon icon={faPen} color="#fff" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item
                        onClick={() => {
                          setTagSelecionada(tag);
                          setOpenModal(true)
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faEdit}
                            color="#B5DEFF"
                            style={{ marginRight: 10 }}
                        />
                        Editar
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() =>{
                          handleRemoverTag(tag)
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            color="#E05D5D"
                            style={{ marginRight: 10 }}
                        />
                        Remover
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
          </th>
        </tr>
      )
    });
  }, [tagsLista, filtroNome])

  const handleSalvarTag = (data) => {
    setOpenModal(false);
    let metodo = tagSelecionada?.id_tag ? caAPI.tags.update(data?.nome, tagSelecionada?.id_tag) : caAPI.tags.create(data?.nome);
    trackPromise(metodo).then((response) => {
      if(tagSelecionada?.id_tag){
        setTagsLista((prev) => prev.map((item) => item.id_tag === response.data.id_tag ? response.data : item));
      }else{
        setTagsLista((prev) => [...prev, response.data].sort((a, b) => a.nome.localeCompare(b.nome)));
      }
      setTagSelecionada(null);
      successToast.fire("Tag salva com sucesso!");
    }).catch((error) => {
      Swal.fire({
        title: "Ops!",
        text: "Ocorreu um erro ao salvar a tag de atendimento. Tente novamente.",
        icon: "error",
      })
    })
  }

  const handleRemoverTag = useCallback((tag) => {
    Swal.fire({
      position: 'center',
      icon: "question",
      html: `Deseja remover a tag: <br><b>${tag.nome}</b>?`,
      showCloseButton: false,
      showCancelButton: true,
      confirmButtonText: 'Sim, remover',
      cancelButtonText: 'Não, manter',
      width: '400px',
      customClass: {
        confirmButton: 'btn btn-danger mr-2',
        cancelButton: 'btn btn-secondary',
      },
      buttonsStyling: false,
    }).then((result) => {
        if ( result.isConfirmed) {
          trackPromise(caAPI.tags.delete(tag.id_tag)).then(() => {
            setTagsLista((prev) => prev.filter((item) => item.id_tag !== tag.id_tag));
            successToast.fire("Tag removida com sucesso!");
          }).catch((error) => {
            Swal.fire({
              title: "Ops!",
              text: "Ocorreu um erro ao remover a tag de atendimento. Tente novamente.",
              icon: "error",
            })
          })
        }
    })
  }, [tagsLista])

  return (
    <>
      <Container fluid className="container-tags-atendimento">
          <DommusBarraTitulo>
              <ItemBarraTitulo classe="">
                 Tags Atendimento 
                <input 
                  placeholder="Filtrar por nome"
                  type="text" 
                  onChange={(e) => setFiltroNome(e.target.value)}
                  className="filtro-nome-tag"
                />
              </ItemBarraTitulo>
              <ItemBarraTitulo
                  classe="btn"
                  onClick={() => {
                      setOpenModal(true)
                  }}
                  data-tip={`Cadastrar nova tag de atendimento`}
              >
                  <FontAwesomeIcon icon={faPlusCircle} color="#4caf50" />
              </ItemBarraTitulo>
          </DommusBarraTitulo>
          <section className="tags-section">
            <DommusTabelaPaginada
              linhasCabecalho={thead}
              optionsTabela={{}}
              linhasCorpo={trows}
              customClasses={"overflow-auto"}
            />
          </section>
      </Container>
      <ModalDommus
        open={openModal}
        close={() => {
          setTagSelecionada(null);
          setOpenModal(false)
        }}
        titulo={`Tags de Atendimento`}
        size={"md"}
      >
        <FormTagAtendimento 
          tag={tagSelecionada}
          handleSalvarTag={handleSalvarTag}
          closeModal={() => setOpenModal(false)}
        />
      </ModalDommus>
    </>
  )
}
